import { RATING_GROUP_API } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { fetchRatingGroupAllFailure, fetchRatingGroupAllSuccess } from "./reducer";

export const getRatingGroupAll = (setLoading,ratingGroup,serviceIdentifier,serviceContextID) => (dispatch) => {
    setLoading(true);
    determineBaseUrlAndPerformApiCall(`${RATING_GROUP_API}?ratingGroup=${ratingGroup || 0}&serviceIdentifier=${serviceIdentifier}&serviceContextID=${serviceContextID}`, 'GET')
        .then((response) => {
            setLoading(false);
            dispatch(fetchRatingGroupAllSuccess(response));
        })
    .catch ((errorResp) => { dispatch(fetchRatingGroupAllFailure(errorResp.message)); })
}